import { Component, computed, ElementRef, HostListener, Inject, input, viewChildren } from '@angular/core';
import { LosDefType, ModuleLosdef } from '../../PropTypes';
import { PropsServiceService } from '../../props-service.service';
import { KopConfigService } from '../../../core/kop-config.service';
import { cKC_LosDef, cKC_LosDefs, Losdef } from '@wasm/KopWeb';
import { wasmVectorToArray } from '../../../utils/wasmVector';
import { TranslateService } from '../../../i18n/translate.service';
import { BaseListComponent } from '../../../keynav/base-list/base-list.component';
import { FocusManagerService } from '../../../keynav/focus-manager.service';
import { LosDefEditorComponent } from '../../los-def-editor/los-def-editor.component';
import { BaseElementComponent } from '../../../keynav/base-element/base-element.component';

@Component({
  selector: 'klassiek-los-def',
  templateUrl: './klassiek-los-def.component.html',
  styles: `
  .button {
    width: 100%;
  }
  .wrapper {
    max-height: 600px;
  }
  `,
})
export class KlassiekLosDefComponent extends BaseListComponent {

  constructor(public propsService: PropsServiceService, public kopConfigService: KopConfigService, public translateService: TranslateService,
    @Inject('i18n-label') private i18nLabel: any,elementRef: ElementRef<HTMLElement>, focusManager: FocusManagerService) {
    super(elementRef,focusManager);
    this.keyProperty = "klassiek-los-def";
  }
  public type = input<LosDefType>('losdef');

  public label = computed(() => {
    let type = this.type();
    let repo = this.translateService.translateSignal();
    switch (type) {
      case 'losdef': return this.translateService.getTranslationSync(repo, this.i18nLabel, 'Losse Definities', 'Losse Definities');
      case 'koeling': return this.translateService.getTranslationSync(repo, this.i18nLabel, 'Koeling', 'Koeling');
      case 'verwarming': return this.translateService.getTranslationSync(repo, this.i18nLabel, 'Verwarming', 'Verwarming');
      case 'droogwand': return this.translateService.getTranslationSync(repo, this.i18nLabel, 'Droogwand', 'Droogwand');
      default: return '';
    }
  });

  public filled = computed(() => {
    let type = this.type();
    switch (type) {
      case 'losdef': return this.propsService.losDefs();
      case 'koeling': return this.propsService.koelings();
      case 'verwarming': return this.propsService.verwarmings();
      case 'droogwand': return this.propsService.drogWands();
      default: return [];
    }
  });

  public metas = computed(() => {
    let type = this.type();
    let t: Losdef[] = [];
    switch (type) {
      case 'losdef': return this.kopConfigService.currentMeta().losDefs;
      case 'koeling': return this.kopConfigService.currentMeta().koelings;
      case 'verwarming': return this.kopConfigService.currentMeta().verwarmings;
      case 'droogwand': return this.kopConfigService.currentMeta().drogWands;
    }
    return t;
  });

  public losDefs = computed(() => {
    return this.metas().sort((a, b) => a.volgorde - b.volgorde).map(m => this.findLD(m));
  });

  public findLD(meta: Losdef): ModuleLosdef {
    let ret = this.filled().find(ld => ld.index == meta.index);
    if (ret != undefined) {
      return ret;
    }
    return this.kopConfigService.findOrBuildLosDef(meta, this.type());
  }

  public aiEditors = viewChildren(LosDefEditorComponent);
  public getChildren(): readonly BaseElementComponent[] {
    return this.aiEditors();
  }


}
